import { Component, Input, OnInit } from '@angular/core';
import { Observable, take } from 'rxjs';
import { Test } from '../models/test.model';
import { Question } from '../models/question.model';
import { select, Store } from '@ngrx/store';
import { fromTest } from '../reducers/test.reducer';
import { fromQuestion } from '../reducers/question.reducer';
import { setQuestion } from '../actions/question.actions';
import { QuestionService } from '../services/question.service';

@Component({
  selector: 'ct-level-completed',
  templateUrl: './level-completed.component.html',
  styleUrls: ['./level-completed.component.scss']
})
export class LevelCompletedComponent implements OnInit {

  @Input() colors: any;

  test$: Observable<Test>;
  question$: Observable<Question>;

  public digitalLevelNames = {
    9: 'BASIC',
    10: 'INTERMEDIATE',
    11: 'ADVANCE'
  };

  constructor(
    private questionService: QuestionService,
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.test$ = this.store.pipe(select(fromTest.selectTestState));
    this.question$ = this.store.pipe(select(fromQuestion.selectQuestionState));
  }

  nextQuestion() {
    this.test$.subscribe(test => {
      this.questionService.getNextQuestion(test.token).subscribe(questions => {
        this.store.dispatch(setQuestion(questions));
        // this.store.dispatch(setTest({ ...test, startedAt: question.testStartedAt }));
      });
    }, error => {
      console.log(error);
    });
  }

  getExamplesNextLevel() {
    this.question$.pipe(take(1)).subscribe(currentQuestion => {
      this.store.dispatch(setQuestion({ ...currentQuestion, levels: [], levelCompleted: false }));
    });
  }

}
